module.exports = __webpack_public_path__ + "static/img/5.a52dadd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/sp/5.png
// module id = TCEc
// module chunks = 0